import Image from 'next/image';
import { handleTrack } from '../../../utils/tracker';
import { ContentTable } from './styles';

interface ContentInterface {
  id: string;
  header: string;
}

interface TableOfContentsProps {
  data: Array<ContentInterface>;
}

const TableOfContents = ({ data }: TableOfContentsProps): JSX.Element => {
  return (
    <ContentTable>
      <div className="flex items-center content-header">
        <Image
          src="https://assets1.cleartax-cdn.com/cleartax/images/1646060201_button.svg"
          alt="content"
          height="12"
          width="18"
          className="h-3"
        />
        <div className="font-bold pl-4">Table of contents</div>
      </div>
      <ul className="py-6 sm:py-0">
        {data.map((content) => (
          <li className="py-2 text-s-14 text-font-500" key={content.id}>
            <div
              className="w-full text-font-500 cursor-pointer"
              onClick={(e) => {
                handleTrack({
                  label: 'rhs_cta',
                  obj: e.target,
                });
                window.location.hash = '#' + content.id;
              }}
            >
              <div className="sm:hidden">{content.header}</div>
              <div className="md:hidden lg:hidden xl:hidden flex items-center">
                <div className="w-1/12">&bull;</div>
                <div className="w-9/12">{content.header}</div>
                <div className="w-2/12 text-base text-right">&gt;</div>
              </div>
            </div>
          </li>
        ))}
      </ul>
    </ContentTable>
  );
};

export default TableOfContents;
